export const SET_INFORMATION_IMPORTED = (state, result) => {
  state.list = result
  state.correct = result.filter(elem => elem.result === false).length
  state.incorrect = result.filter(elem => elem.result).length
  state.notTreated = result.filter(elem => elem.result === null).length
}
